'use client'
import { Box, Stack, Typography } from '@mui/material'
import { usePathname, useRouter } from 'next/navigation'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import React, { useEffect, useRef, useState } from 'react'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'
import { BaseImage } from '@biolumina/ui/components/baseImage/baseImage'
import Link from '@biolumina/ui/components/link/link'
import MobileNav from './components/nav/components/mobileNav/mobileNav'
import DesktopNav from './components/nav/components/desktopNav/desktopNav'
import TopLinks from './components/topLinks'
import { usePageData } from '@biolumina/ui/hooks/pageData.hook'
import { StyledHeader } from './header.styles'

const defaultLogo = '/images/logo-header.svg'

export const Header = ({ logo = defaultLogo }) => {
  const router = useRouter()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  })
  const { setScrollMargin, scrollMargin } = useGlobalState()
  const [hideHeaderTop, setHideHeaderTop] = useState(false)
  const lastScrollY = useRef(0)
  const pathname = usePathname().replaceAll('/', '')
  const pageData = usePageData()
  const hasChildren = pageData.children && pageData.children.length

  useEffect(() => {
    setScrollMargin(
      isMobile ? (hideHeaderTop ? 60 : 141) : hasChildren ? 201 : 141
    )
  }, [pathname, isMobile, setScrollMargin, hideHeaderTop, hasChildren]) // Scroll to hash target after scrollMargin is set and page is loaded

  /* useEffect(() => {
    if (window.location.hash) {
      const targetId = window.location.hash.substring(1)
      setTimeout(() => {
        const targetElement = document.getElementById(targetId)
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
          })
        }
      }, 200) // 200ms delay to allow layout and scrollMargin to update
    }
  }, []) */

  // Add smooth scroll handler for anchor links
  // Add smooth scroll handler for anchor links
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const link = e.target.closest('a')
      if (!link) return

      const href = link.getAttribute('href')
      if (!href || !href.startsWith('#isi')) return

      // If on sitemap page, navigate to /#isi using router
      if (window.location.href.indexOf('sitemap') > -1) {
        e.preventDefault()
        router.push('/#isi')
        return
      }

      /* e.preventDefault()
      const targetId = href.substring(1)

      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
        })
        // Update URL hash without jumping
        history.pushState(null, null, href)
      } */
    }

    document.addEventListener('click', handleAnchorClick, true)

    return () => {
      document.removeEventListener('click', handleAnchorClick, true)
    }
  }, [router.asPath])

  return (
    <>
      <StyledHeader
        className={`page-wrapper ${hideHeaderTop ? 'page-scrolled' : ''}`}
      >
        <Box className={`header-wrapper`} p={theme.spacing(0, 1)}>
          <Typography
            className="hcp-line"
            sx={{ textWrap: 'nowrap', fontSize: { xs: '12px', md: '14px' } }}
          >
            This site is intended for US residents only. <span className='mobile-only'></span>IBTROZI is brought to you by Nuvation Bio Inc. 
          </Typography>
          <Stack direction="row" alignItems="center">
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <Link
                data-tracking="header-home-logo"
                style={{ display: 'block' }}
                href={'/'}
              >
                <BaseImage
                  pictureSx={{ display: 'flex' }}
                  src={logo}
                  sx={{ height: '69px', margin: '10px', marginTop: '15px' }}
                  alt="IBTROZI® (taletrectinib) logo"
                />
              </Link>
            </Box>
            <Box
              sx={{
                maxWidth: 1366,
                width: '100%',
                mx: 'auto',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                position: 'relative',
              }}
            >
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                sx={{
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <TopLinks />
                <Stack
                  className="mobile-container"
                  display={{ xs: 'flex', md: 'none' }}
                  direction="row"
                  width="100%"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Link
                    data-tracking="header-home-logo"
                    style={{ display: 'flex' }}
                    href={'/'}
                  >
                    <BaseImage
                      pictureSx={{ display: 'flex' }}
                      src={logo}
                      sx={{ height: '42px' }}
                      alt="IBTROZI® (taletrectinib) logo"
                    />
                  </Link>
                  <MobileNav />
                </Stack>
              </Stack>
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <DesktopNav />
              </Box>
            </Box>
          </Stack>
        </Box>
      </StyledHeader>
      <Box
        sx={{
          height: { xs: '141px', md: `${scrollMargin}px` },
          position: 'relative',
          zIndex: 4,
          boxShadow: 'none',
          bgcolor: 'white',
        }}
      />
    </>
  )
}
